/***
 *
 *   ONBOARDING
 *   Single-page welcome that finishes to /dashboard.
 *
 **********/

import { Fragment, useContext } from "react";
import { AuthContext, Onboarding, Alert } from "components/lib";

export function OnboardingView({ t }) {
  const authContext = useContext(AuthContext);

  const views = [];

  if (authContext.user.duplicate_user) {
    views.push({
      name: t("onboarding.duplicate_user.title"),
      description: "",
      component: <DuplicateUser t={t} />,
    });
  }

  views.push({
    name: t("onboarding.welcome.title"),
    description: `${t("onboarding.welcome.description")}, ${authContext.user.name}!`,
    component: <Welcome t={t} />,
  });

  return <Onboarding save onFinish="/dashboard" views={views} />;
}

function DuplicateUser({ t }) {
  return (
    <Alert
      variant="warning"
      title={t("onboarding.duplicate_user.message.title")}
      description={t("onboarding.duplicate_user.message.description")}
    />
  );
}

function Welcome({ t }) {
  return (
    <Fragment>
      <p className="text-white/90 poppins-regular leading-relaxed">
        {t("onboarding.welcome.text.0")}
      </p>
      <p className="text-white/90 poppins-regular leading-relaxed">
        <strong className="poppins-medium text-white">
          {t("onboarding.welcome.text.1")}
        </strong>
      </p>
    </Fragment>
  );
}
